export enum RawEmailProcessingStatusType {
  RECEIVED = 'RECEIVED',
  PARSED = 'PARSED',
  RECEIVING_FAILED = 'RECEIVING_FAILED',
  PARSING_FAILED = 'PARSING_FAILED',
  FAILED = 'FAILED',
}

export enum EmailActorType {
  CUSTOMER = 'CUSTOMER',
  EMPLOYEE = 'EMPLOYEE',
  SYSTEM = 'SYSTEM', // this will represent system generated actors like automated emails
  RESTAURANT = 'RESTAURANT',
}

export enum EmailContextType {
  CATERING = 'catering',
}

export enum EmailParticipantRole {
  FROM = 'FROM',
  TO = 'TO',
  CC = 'CC',
}

export enum MailboxFolder {
  INBOX = 'INBOX',
  SENT = 'SENT',
  DRAFT = 'DRAFT',
  TRASH = 'TRASH',
  SPAM = 'SPAM',
}

export enum EmailDeliveryStatus {
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  COMPLAINT = 'COMPLAINT',
  REJECTED = 'REJECTED',
  RENDERING_FAILURE = 'RENDERING_FAILURE',
  DELIVERY_DELAY = 'DELIVERY_DELAY',
  FAILED = 'FAILED',
  BOUNCED = 'BOUNCED',
}

// Complaint, Subscription (ses sub management), Reject (virus), Rendering Failure (template only), Delivery Delay

export enum EmailAuditErrorEntity {
  EMAIL_MESSAGE = 'EmailMessage',
  EMAIL_ACTOR = 'EmailActor',
  EMAIL_THREAD = 'EmailThread',
  // Add more entity types as necessary
}

export enum EmailAuditErrorType {}

export interface IAttachment {
  filePath: string;
  fileSize: number;
  mimeType: string;
  fileName: string;
}

export interface Participant {
  name?: string;
  address: string;
  order?: number;
}
